import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("circle", {
  cx: "12",
  cy: "12",
  r: "10"
}), 'Brightness1');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/Brightness1.js
// module id = 2473
// module chunks = 2